// ----------------------------------------------------------------------

export default function LoadingButton(theme) {
  return {
    MuiLoadingButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          '&.MuiButton-containedPrimary': {
            background: theme.palette.gradients.buttonPrimary,
            color: '#fff',
            boxShadow: 'none',
            '&:hover': {
              background: theme.palette.gradients.buttonPrimary,
              filter: 'brightness(0.95)',
              boxShadow: 'none',
            },
            '&.Mui-disabled': {
              background: '#E5E7EB',
              color: '#a0a1a3',
            },
          },
          '&.MuiButton-text': {
            '& .MuiLoadingButton-startIconPendingStart': {
              marginLeft: 0,
            },
            '& .MuiLoadingButton-endIconPendingEnd': {
              marginRight: 0,
            },
          },
        },
      },
    },
  };
}
